// socket_store.js
import { create } from "zustand";

export const useSocketStore = create((set) => ({
  socket: null,
  setSocket: (socket) => set({ socket }),
  clearSocket: () => set({ socket: null }),
}));



// WEBPACK FOOTER //
// ./src/store/slices/NotificationSlice/notification_slice.js